import { useTelescopeContext } from "@hubble/telescope";

export function FullScreenLoaderTelescope() {
  const { components } = useTelescopeContext();
  return (
    <div class="fixed inset-0 flex items-center justify-center bg-background-mapping-reverse">
      <components.Loader size="small" />
    </div>
  );
}
